export default "__VITE_ASSET__DAVHLf4q__"